import { Accordion, Form, Tab } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledFeedTab = styled(Tab)`
margin-left: 10px;
.ui.secondary.pointing.menu .item {
  font-size: 14px !important;
  font-weight: 500 !important;
 }
`
export const StyledField = styled(Form.Field)`
  .ui.menu {
    width: fit-content !important; 
  }
  .subSection {
    font-size: 16px !important;
  }
  .disabled {
    opacity: 1 !important;
  }
`
export const UnitStyled = styled.div`
font-size: 12px !important;
font-weight: 500 !important;
`
export const StyledAccordion = styled(Accordion) <{ $error?: boolean }>`
margin: 20px 0px;
width: 100% !important;
margin-top: 15px;
 .title {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: black !important;
 }
 .accordion-title {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 15px !important;
 }
`
export const FeedGroupsWrapper = styled.div`
 .error-feed-group {
  box-shadow: 0 1px 2px 0 red,0 0 0 1px red !important; 
 }
 .subSection {
  div {
    font-size: 15px !important;
    font-weight: bold;
  }
 }
`